export default __webpack_public_path__ + "static/media/chickita-hands-up.09cf0f87.png";